import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import { Map as ImmutableMap } from 'immutable';

import { cxHelpers } from 'util/className';
import { moment } from 'util/dateTime';
const { cx, cxEl } = cxHelpers('EditHistoryEvent');

function formatTime(timeString: string) {
  return moment(timeString).format('ddd, MMM D \xa0|\xa0 h:mm A');
}

interface EditHistoryEventProps {
  activitiesGroup: ImmutableMap<string, any>;
}

const EditHistoryEvent = ({ activitiesGroup }: EditHistoryEventProps) => (
  <Box pt={16} className={cx()}>
    <Box bcolor="mono400" bradiuss bw={1} p={12}>
      <Box pb={4}>
        <Text variant="bodyBold" color="mono900" asHTML>
          {activitiesGroup.get('title')}
        </Text>
      </Box>

      {activitiesGroup
        .get('activities')
        .map((activity: ImmutableMap<string, any>, i: number) => (
          <Box key={i} className={cxEl('activity')}>
            <Text variant="body" color="mono900" asHTML>
              {activity.get('body')}
            </Text>
          </Box>
        ))}
    </Box>

    <Box pt={4}>
      <Text variant="captions" color="mono700" asHTML>
        {`${formatTime(activitiesGroup.get('time'))}`}
      </Text>
    </Box>
  </Box>
);

export default EditHistoryEvent;
